<template>
  <div>
    <v-img height="120" src="/images/animated-gif-maker.gif" alt="Arrow Icon" />
    <div class="loading-label">{{ currentText }}</div>
  </div>

  <div class="progress-container-outer mt-4">
    <div class="progress-container">
      <div
        class="progress-bar"
        id="progress-bar"
        :style="{ width: `${displayProgress}%` }"
      >
        <div class="progress-number">{{ Math.round(displayProgress) }}%</div>
      </div>
    </div>
  </div>

  <div v-if="useSocket && progressMessage" class="socket-message mt-4">
    {{ progressMessage }}
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    socketMessage: {
      type: String,
      default: "",
    },
    useSocket: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    progressMessage() {
      const resourceId = this.getResourceId();
      const latestProgress = this.getLatestProgress(resourceId, {
        progress: this.progress,
        message: this.socketMessage,
      });
      return latestProgress ? latestProgress.message : this.socketMessage;
    },
  },
  data() {
    return {
      textList: [
        "Digital whiteboards foster collaborative creativity!",
        "Virtual reality turns lessons into adventures!",
        "Math games make numbers exciting!",
        "Tech tools tailor lessons to learners!",
        "3D printing turns ideas into reality!",
        "Animation tools bring art classes alive!",
        "Music apps harmonize theory and practice!",
        "Tech makes learning interactive and engaging!",
        "Coding for kids sparks early innovation!",
        "Interactive maps explore history's landscapes!",
        "Environmental apps foster green education!",
        "Educational VR immerses in ancient history!",
        "STEM kits spark scientific curiosity!",
        "Mind mapping software organizes ideas!",
        "AI companions make learning less lonely!",
        "Digital storytelling sparks joyful writing!",
        "Gaming apps fuel happy learning adventures!",
        "Music apps harmonize creativity and tech!",
        "Animation tools unleash happy animators!",
        "DIY electronics kits ignite joyful invention!",
      ],
      currentIndex: 0,
      currentText: "Engaging Artificial Intelligence",
      displayProgress: 0,
      progressInterval: null,
      targetProgress: 0,
    };
  },
  watch: {
    progress(newVal) {
      if (this.useSocket) {
        const resourceId = this.getResourceId();
        const { progress } = this.getLatestProgress(resourceId, {
          progress: newVal,
          message: this.socketMessage,
        });

        this.targetProgress = progress;
        this.smoothProgressTransition();
      }
    },
  },
  methods: {
    getLatestProgress(resourceId, { progress, message }) {
      return { progress, message };
      // const currentRawData = localStorage.getItem(`data_${resourceId}`)
      // if (currentRawData) {
      //   const currentData = JSON.parse(currentRawData)
      //   if (progress > currentData.progress) {
      //     localStorage.setItem(`data_${resourceId}`, JSON.stringify({ progress, message }))
      //     return { progress, message }
      //   } else {
      //     return currentData
      //   }
      // } else {
      //   localStorage.setItem(`data_${resourceId}`, JSON.stringify({ progress, message }))
      //   return { progress, message }
      // }
    },
    getResourceId() {
      const data = this.$route.query?.data
        ? JSON.parse(this.$route.query?.data)
        : null;
      if (data) {
        const { resource_id } = data;
        return resource_id;
      }
      return null;
    },
    smoothProgressTransition() {
      // Clear any existing interval
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
      }

      const step = 0.5; // Smaller step for smoother transition
      this.progressInterval = setInterval(() => {
        if (Math.abs(this.displayProgress - this.targetProgress) < step) {
          this.displayProgress = this.targetProgress;
          clearInterval(this.progressInterval);
        } else if (this.displayProgress < this.targetProgress) {
          this.displayProgress += step;
        } else {
          this.displayProgress -= step;
        }
      }, 20); // Shorter interval for smoother animation
    },
    animateProgressBar() {
      let width = 0;
      const interval = setInterval(() => {
        if (width >= 85) {
          clearInterval(interval);
        } else {
          width++;
          this.displayProgress = width;
        }
      }, 40);
    },
    startTextRotation() {
      this.currentText = this.textList[0];
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.textList.length;
        this.currentText = this.textList[this.currentIndex];
      }, 4000);
    },
    initializeSocketProgress() {
      this.displayProgress = 0;
      this.targetProgress = 30;
      this.smoothProgressTransition();
    },
  },
  mounted() {
    this.startTextRotation();

    if (this.useSocket) {
      this.initializeSocketProgress();
    } else {
      this.animateProgressBar();
    }
  },
  beforeUnmount() {
    // Clean up intervals
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  },
};
</script>

<style scoped>
.progress-container-outer {
  width: 30%;
  margin: 0 auto;
  position: relative;
}

.progress-container {
  width: 100%;
  background: #f2f3fb;
  border-radius: 25px;
  padding: 3px;
  position: relative;
}

.progress-bar {
  width: 0;
  height: 10px;
  background: var(--primary-blue);
  border-radius: 25px;
  position: relative;
}

.progress-number {
  color: #ffffff;
  font-family: "League Spartan";
  position: absolute;
  right: 5px;
  top: -2px;
  font-size: 0.7em;
}

.loading-label {
  font-family: "League Spartan";
  color: var(--primary-blue);
  text-align: center;
}

.socket-message {
  font-family: "League Spartan";
  color: var(--primary-blue);
  text-align: center;
  font-style: italic;
  font-size: 0.9em;
}
</style>
